export const GET_SETTING = "GET_SETTING";
export const UPDATE_SETTING = "UPDATE_SETTING";